module.exports = __webpack_public_path__ + "img/quelle_valeur_ajoute.9a0f27cc.jpg";